import axios from './_nestAxios'

export const obtenerxIdDocumentoPrincipalAsInfoDetraccion = idDocumentoPrincipal =>
  axios.get(`/documentos-relacionados/documento-principal/${idDocumentoPrincipal}`, {
    params: { tipoConsulta: 'detraccion' }
  })

export const nuevaDetraccion = body => axios.post('/documentos-relacionados', body, { params: { tipoConsulta: 'detraccion' } })

export const actualizarDetraccionxId = (id, body) => axios.post(`/documentos-relacionados/${id}`, body, { params: { tipoConsulta: 'detraccion' } })
